import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-hero min-h-0 md:min-h-screen flex items-start pt-6 pb-8 md:pt-6 md:pb-10 relative overflow-hidden" data-id="element-138">
      {/* Decorative gold lines */}
      <div className="absolute left-[10%] md:left-[20%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/20 to-transparent" data-id="element-139" />
      <div className="absolute right-[10%] md:right-[20%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/20 to-transparent" data-id="element-140" />

      <div className="max-w-[1400px] mx-auto px-4 md:px-8 w-full relative z-10" data-id="element-141">
        <div className="flex flex-col items-center text-center" data-id="element-142">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-143">
            <div className="inline-block bg-gradient-cta px-2 py-1 rounded-full mb-3 md:mb-4" data-id="element-144">
              <span className="text-[10px] font-bold uppercase tracking-widest text-primary-foreground" data-id="element-145">
                Oferta de lanzamiento
              </span>
            </div>
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="font-display text-[36px] md:text-4xl lg:text-5xl font-extrabold leading-[1.1] md:leading-tight tracking-tight max-w-4xl" data-id="element-146">
            Esto no es falta de disciplina.
            <br data-id="element-147" />
            <span className="text-gradient-gold" data-id="element-148">Es hormonal.</span>
            <br data-id="element-149" />
            <span className="text-[20px] md:text-2xl lg:text-3xl font-bold text-foreground/75 block mt-5 mb-4" data-id="element-150">
              Tu cuerpo cambió. Y tu estrategia también.
            </span>
            <span className="text-gradient-gold text-[28px] md:text-3xl lg:text-4xl block mt-2" data-id="element-151">
              En 21 días podés sentirte más liviana y recuperar tu energía.
            </span>
          </motion.h1>

          {/* Subhead */}
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="text-[15px] md:text-[18px] lg:text-[20px] font-body font-normal tracking-wide mt-3" style={{
          lineHeight: '1.45',
          color: 'rgba(255, 255, 255, 0.88)'
        }} data-id="element-152">
            Sin dietas extremas. Sin rutinas imposibles.
            <br data-id="element-153" />
            Porque el problema no es lo que comés…
            <br data-id="element-154" />
            <span className="font-bold" data-id="element-155">es cómo tu cuerpo responde ahora.</span>
          </motion.p>

          {/* CTA — moved above bullets */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.25
        }} className="pt-5 md:pt-6 flex flex-col items-center w-full space-y-3" data-id="element-156">
            <CTAButton onClick={scrollToOffer} data-id="element-157">
              QUIERO VOLVER A SENTIRME BIEN
            </CTAButton>

            <div className="flex flex-col items-center gap-1" data-id="element-158">
              <p className="text-[13px] md:text-sm font-body font-medium" style={{
              lineHeight: '1.3',
              color: 'rgba(255, 255, 255, 0.75)'
            }} data-id="element-159">
                Acceso inmediato + extras incluidos
              </p>
              <p className="text-[13px] md:text-sm font-body font-medium" style={{
              lineHeight: '1.3',
              color: 'rgba(255, 255, 255, 0.65)'
            }} data-id="element-160">
                Garantía de 30 días · Pago 100% seguro
              </p>
            </div>
          </motion.div>

          {/* Pain identification block */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="mt-8 max-w-[90%] md:max-w-xl text-left space-y-4" data-id="element-161">
            <h3 className="text-xl md:text-2xl font-display font-bold text-center leading-snug" style={{
            color: 'rgba(255, 255, 255, 0.95)'
          }} data-id="element-162">
              🔥 Esto es lo que probablemente te está pasando:
            </h3>
            <ul className="space-y-2.5" data-id="element-163">
              {['Dormís… pero te despertás agotada igual.', 'Comés igual que antes, pero tu cintura cambió y nada entra como antes.', 'Tu cabeza no acompaña: te cuesta concentrarte y vivís cansada mentalmente.', 'Antes hacías todo sin esfuerzo. Ahora cualquier cosa te drena energía.', 'Sentís que tu cuerpo cambió… y no entendés por qué.'].map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.4 + i * 0.08
            }} className="flex items-start gap-3" data-id="element-164">
                  <span className="text-accent mt-0.5 flex-shrink-0" data-id="element-165">✕</span>
                  <span className="text-base md:text-lg font-body font-medium leading-relaxed" style={{
                color: 'rgba(255, 255, 255, 0.88)'
              }} data-id="element-166">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
            <motion.p initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.8
          }} className="text-lg md:text-xl font-display font-bold text-center pt-5 pb-2 mt-2 leading-relaxed" data-id="element-167">
              <span className="text-gradient-gold" data-id="element-168">
                No es tu culpa. Es hormonal.
              </span>
              <br data-id="element-169" />
              <span className="font-body font-medium text-base md:text-lg" style={{
              color: 'rgba(255, 255, 255, 0.85)'
            }} data-id="element-170">
                Después de los 35, tu cuerpo cambia.
                <br data-id="element-171" />Y lo que antes funcionaba… ya no alcanza.
              </span>
            </motion.p>
          </motion.div>

          {/* Ebook Image — below pain block */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="relative flex justify-center mt-5 mb-5" data-id="element-172">
            <div className="relative w-full max-w-[18rem]" data-id="element-173">
              <div className="rounded-2xl shadow-gold overflow-hidden border border-gold/20" data-id="element-174">
                <img src="https://cdn.magicpatterns.com/uploads/o21DXiNfJf4CXggkc9b5QV/7hYPKk5dmKP8Obaox-4nJ.png" alt="Protocolo H.E.R." className="w-full h-auto object-cover" data-id="element-175" />
              </div>
            </div>
          </motion.div>

          {/* Guide intro */}
          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.55
        }} className="text-lg md:text-2xl font-display font-bold leading-relaxed max-w-[90%] md:max-w-2xl mt-4 text-gradient-gold" data-id="element-176">
            La guía de 21 días que te dice exactamente qué hacer para acompañar
            los cambios de tu cuerpo sin improvisar.
          </motion.p>

          {/* Subtitle */}
          <motion.p initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.65
        }} className="text-lg md:text-2xl text-foreground/90 font-body leading-relaxed max-w-[90%] md:max-w-2xl mt-4" data-id="element-177">
            En los primeros días, muchas mujeres empiezan a notar menos
            hinchazón, más estabilidad y una sensación real de bienestar… y
            vuelven a sentirse en control de su cuerpo.
          </motion.p>

          <p className="text-[14px] md:text-[15px] font-body font-normal leading-normal max-w-[90%] md:max-w-md mt-4" style={{
          color: 'rgba(255, 255, 255, 0.6)'
        }} data-id="element-178">
            Resultados variables según contexto individual y nivel de
            adherencia. Este programa es educativo y no reemplaza consulta
            médica personalizada.
          </p>
        </div>
      </div>
    </section>;
}